import { DesignMenu } from '../DesignMenu/DesignMenu';
import SelectPage from './SelectPage/SelectPage';
import { PaginationButton } from '../PaginationButton/PaginationButton';
import { CanvasComponent } from '../Canvas/CanvasComponent';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { SelectedPageList } from './SelectPage/SelectedPageList';
import { PossibleClosetList } from './PossibleClosets/PossibleClosetList';
import DownloadClosetLayoutList from './DownloadClosetLayoutList';
import MatrixCalculator from './matrix/MatrixCalculator';
import MappingCollapse from './mapping/MappingCollapse';
import PredictClosetButton from '../Canvas/Predict-Closet/PredictClosetButton';
import { VALID_EMAIL } from '../../constant';

export const WorkSpace = observer(() => {
    const { viewManager } = useMainContext();
    const user = viewManager.userData;
    const matches = user.email.match(/\b[A-Za-z0-9._%+-]+@hexacoder\.com\b/g);
    const isValidEmail = matches?.length !== 0 || user.email == VALID_EMAIL;
    return (
        <div className="h-[calc(100vh-80px)] relative overflow-y-hidden">
            {/* <DesignMenu /> */}
            <PaginationButton />
            {[2, 3].includes(viewManager.selectedMenu) && (
                <>
                    {viewManager.selectedMenu === 2 ? (
                        <>
                            {/* <SelectedPageList
                                selectedPages={viewManager.selectedPages}
                            /> */}
                            <PossibleClosetList />
                            {isValidEmail && <PredictClosetButton />}
                            <MappingCollapse />
                        </>
                    ) : (
                        <>
                            <MatrixCalculator />
                            {/* <FloatingUnitTable /> */}
                            <DownloadClosetLayoutList />
                        </>
                    )}
                    <CanvasComponent />
                    {/* {(viewManager.selectedMenu === 3 ||
                        viewManager.selectedMenu === 2) && <PageSwitcher />} */}
                </>
            )}

            {/* {viewManager.selectedMenu === 1 && <SelectPage />} */}
        </div>
    );
});
